import { createWebHistory, createRouter } from "vue-router";

import HomePagePlotix from "../components/Pages/HomePagePlotix";
import HomePageAboutUs from "../components/Pages/HomeAboutUs";

const routes = [
  { path: "/", name: "HomePagePlotix", component: HomePagePlotix },
  { path: "/sobrenosotros", name: "HomePageAboutUs", component: HomePageAboutUs },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
